<template>
    <exportTemplate ref="exportTemplate" :showExport="false" :showCustomColumns="false" placement="top" :formModel="formModel" :table-data="tableList" :table-total="paginationTotal" :table-load="tableLoading" @pagination-change="paginationChange" @form-submit="formSubmit" @form-reset="formReset" @sort="sortChange" @row-dblclick="rowDblclick">
        <template #form>
            <el-form-item label="查询条件" prop="keyWords">
                <el-input placeholder="客户名、联系人、联系人电话、推荐人、推荐人电话等模糊查询" v-model="formModel.keyWords.selected" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <date-picker style="width: 240px;" v-model="formModel.billDate.selected" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions"></date-picker>
            </el-form-item>
        </template>
        <template>
            <el-table-column label="意向客户名称" prop="enterpriseName" min-width="170px" fixed></el-table-column>
            <el-table-column label="企业规模" prop="companySize" width="100"></el-table-column>
            <el-table-column label="联系人" prop="fzrName" width="100"></el-table-column>
            <el-table-column label="联系电话" prop="phone" width="100"></el-table-column>
            <el-table-column label="推荐人" prop="referrerName" width="100"></el-table-column>
            <el-table-column label="推荐人电话" prop="referrerPhone" width="100"></el-table-column>
            <el-table-column label="采集时间" prop="collectionDateTime" width="130"></el-table-column>
            <el-table-column label="客户地址" min-width="120px">
                <template #default="{ row }">
                    <p>{{row.provinceName + row.cityName + row.regionName + row.address}}</p>
                </template>
            </el-table-column>
            <el-table-column label="相关操作" prop="monthQty" width="120">
                <template #default="{ row }">
                    <!-- <el-button type="danger" @click="resetPassword(row)" size="mini">重置密码</el-button> -->
                    <el-button type="primary" @click="dialogShow('edit', row)" size="mini">转正式客户</el-button>
                </template>
            </el-table-column>
        </template>
        <el-dialog title="转正式客户" :visible.sync="dialogVisible" @closed="dialogClose" append-to-body :close-on-click-modal="false" width="650px">
            <template>
                <el-form class="dialogForm" ref="dialogForm" :rules="dialogFormRules" :model="dialogForm" label-width="100px">
                    <el-form-item label="客户名称" prop="enterpriseName">
                        <el-input v-model="dialogForm.enterpriseName" autocomplete="off" placeholder="请输入客户名称"></el-input>
                    </el-form-item>
                    <el-form-item label="管理员账号" prop="userName">
                        <el-input autocomplete="off" v-model.number="dialogForm.userName" placeholder="请输入管理员账号"></el-input>
                    </el-form-item>
                    <el-form-item label="联系电话" prop="phone">
                        <el-input autocomplete="off" v-model.number="dialogForm.phone" placeholder="请输入联系电话"></el-input>
                    </el-form-item>
                    <el-form-item label="端口数" prop="numberOfPort">
                        <el-input v-model.number="dialogForm.numberOfPort" placeholder="请输入端口数"></el-input>
                    </el-form-item>
                    <el-form-item label="签约时间" prop="signDateTime">
                        <el-date-picker @change="dataChange" style="width: 202px;" format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="dialogForm.signDateTime" type="date" placeholder="请选择签约日期"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="到期时间" prop="endDate">
                        <el-date-picker style="width: 202px;" format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="dialogForm.endDate" type="date" placeholder="请选择到期日期"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="备注" prop="remark" type="textarea" :rows="2" style="width: 100%;">
                        <el-input v-model="dialogForm.remark" type="textarea" placeholder="请输入备注"></el-input>
                    </el-form-item>
                    <div style="width: 100%; text-align: center;">
                        <el-button type="primary" @click="onSubmit">提交</el-button>
                        <el-button @click="dialogClose">取消</el-button>
                    </div>
                </el-form>
            </template>
        </el-dialog>
    </exportTemplate>
</template>
<script>
import exportTemplate from '@/components/common/exportTemplate.vue'
import datePicker from '@/components/common/datePicker.vue'
import { pickerOptions, getNowFormatDate, getAddDate, changeYearMonthAndClampDate, getQueryItem } from '@/assets/js/common.js'
export default {
    name: 'intentionDefine',
    components: {
        exportTemplate,
        datePicker
    },
    data() {
        return {
            pickerOptions: pickerOptions,
            params: {
                keyWords: '',
                beginSearchDate: getAddDate(-3),
                endSearchDate: getNowFormatDate(),
                page: 1,
                rows: 20
            },
            formModel: {
                keyWords: { submitName: 'keyWords', selected: '' },
                billDate: { submitName: 'billDate', selected: [getAddDate(-3), getNowFormatDate()] },
            },
            paginationTotal: 0,
            tableList: [],
            tableLoading: false,
            dialogVisible: false,
            dialogForm: {
                enterpriseName: '',
                numberOfPort: '',
                phone: '',
                remark: '',
                endDate: '',
                signDateTime: '',
                userName: ''
            },
            dialogFormRules: {
                'enterpriseName': [
                    { required: true, message: '请输入客户名称', trigger: 'blur' }
                ],
                'numberOfPort': [
                    { required: true, message: '请输入端口数', trigger: 'blur' }
                ],
                'phone': [
                    { required: true, message: '请输入联系电话', trigger: 'blur' }
                ],
                'userName': [
                    { required: true, message: '请输入管理员账号', trigger: 'blur' }
                ],
                'endDate': [
                    { required: true, message: '请选择到期日期', trigger: 'blur' }
                ],
                'signDateTime': [
                    { required: true, message: '请选择签约日期', trigger: 'blur' }
                ],
            },
        }
    },
    created() {
        this.getTableList()
    },
    methods: {
        paginationChange({ page, size, isGetTable = true }) {
            this.params.page = page
            this.params.size = size
            if (isGetTable) {
                this.getTableList()
            }
        },
        formSubmit() {
        console.log(getQueryItem(this.formModel));
            this.params = { ...this.params, ...getQueryItem(this.formModel) }
            this.params.beginSearchDate = this.params.beginDate
            this.params.endSearchDate = this.params.endDate
            this.getTableList()
        },
        formReset() {
            this.params['sortField'] = ''
            this.params['softBy'] = ''
            this.formModel.billDate.selected = [getAddDate(-3), getNowFormatDate()]
            this.formModel.keyWords.selected = ''
            this.params.page = 1
        },
        async getTableList() {
            this.tableLoading = true
            this.tableData = []
            const { data: res } = await this.$http.post(
                "/Account/monitorCenterEnterDefine/intentionList.html",
                this.Qs.stringify(this.params)
            )
            this.tableLoading = false
            if (res.code != 'success') return this.$message.error(res.message)
            let { data } = JSON.parse(res.result)
            let rows = JSON.parse(data)
            this.paginationTotal = rows.total
            this.tableList = JSON.parse(rows.data)
        },
        sortChange({ sortField, sortBy }) {
            this.params['sortField'] = sortField
            this.params['sortBy'] = sortBy
            this.params.page = 1
            this.getTableList()
        },
        rowDblclick({ row }) {
            console.log(row);
        },
        resetPassword(row) {
            console.log(row);
        },
        dialogClose() {
            this.dialogVisible = false
            this.$refs.dialogForm.resetFields()
        },
        dialogShow(tag, row = {}) {
            let dateTime = getNowFormatDate(new Date())
            this.dialogForm = { ...row, signDateTime: dateTime }
            this.setEndDate(dateTime)
            this.dialogVisible = true
        },
        setEndDate(val) {
            console.log(val);
            let date = new Date(val)
            const year = date.getFullYear();
            const month = date.getMonth();
            let endDate = getNowFormatDate(changeYearMonthAndClampDate(date, year + 1, month))
            console.log(endDate);
            this.$set(this.dialogForm, 'endDate', endDate)
        },
        dataChange(val) {
            this.setEndDate(val)
        },
        onSubmit() {
            this.$refs.dialogForm.validate(async (valid) => {
                if (valid) {
                    const loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    console.log(this.dialogForm);
                    const { data: res } = await this.$http.post(
                        '/Account/monitorCenterEnterDefine/intentionToOfficial.html',
                        this.Qs.stringify(this.dialogForm)
                    )
                    loading.close();
                    if (res.code != 'success') return this.$message.error(res.message)
                    this.$message.success(res.message)
                    this.dialogClose()
                    this.getTableList()
                    console.log(res);
                }
            });
        }
    }
}
</script>
<style lang="less" scoped>
.dialogForm {
    display: flex;
    flex-wrap: wrap;
}
</style>